import { defineAbility } from '@casl/ability'

import { User } from '../../models'
import { Roles, userHasRole } from '../../helpers'

export default (user: User) => defineAbility((can) => {
    if (userHasRole(user, Roles.Standard)) {
        can('Create', 'Supplier')
        can('Edit', 'SupplierStatus')
        can('View', 'SupplierRecordings')
        can('Update', 'SupplierNote')
        can('View', 'SupplierRecovery')
    }

    if (userHasRole(user, Roles.Contributor)) {
        can('Edit', 'Supplier')
        can('View', 'SupplierBalances')
    }

    if (userHasRole(user, Roles.CollectionAgent)) {
        can('View', 'SupplierCallbacks')
        can('View', 'SupplierCollections')
        can('Create', 'CollectionsContact')
        can('Edit', 'CollectionsContact')
        can('Delete', 'CollectionsContact')
        can('Delete', 'SupplierRecording')
        can('Create', 'SupplierInvoice')
        can('Filter', 'SupplierCollections')
        can('Unassign', 'Supplier')
    }

    if (userHasRole(user, Roles.Lead)) {
        can('Delete', 'Supplier')
    }

    if (userHasRole(user, Roles.Executive)) {
        can('Upload', 'SupplierData')
    }

    if (userHasRole(user, Roles.SrLead)) {
        can('Assign', 'Supplier')
        can('Delete', 'SupplierNote')
        can('Upload', 'SupplierData')
        can('Delete', 'SupplierRecording')
        can('Create', 'SupplierInvoice')
        can('Filter', 'SupplierRecovery')
        can('Edit', 'VendorCode')
    }

    if(userHasRole(user, Roles.Tier2)){
        can('Send', 'SupplierInvoiceEmailFollowup')
        can('Create', 'CollectionsContact')
        can('Edit', 'CollectionsContact')
        can('Delete', 'CollectionsContact')
    }

    if(userHasRole(user, Roles.Recovery)) {
        can('View', 'RecoverySuppliers')
    }
})
